<template>
  <div class="help-container-v2">
    <!-- Header -->


    <!-- Content Card -->
    <div class="card help-card-v2">
      <!-- Custom Tabs -->
      <div class="help-tabs-v2">
        <button v-if="videos.length > 0" class="tab-btn-v2" :class="{ 'active': tabIndex === 0 }" @click="tabIndex = 0">
          <i class="fa fa-play-circle"></i>
          Відео
        </button>
        <button class="tab-btn-v2" :class="{ 'active': tabIndex === (videos.length > 0 ? 1 : 0) }"
          @click="tabIndex = videos.length > 0 ? 1 : 0">
          <i class="fa fa-th-large"></i>
          Шаблони
        </button>
        <button class="tab-btn-v2" :class="{ 'active': tabIndex === (videos.length > 0 ? 2 : 1) }"
          @click="tabIndex = videos.length > 0 ? 2 : 1">
          <i class="fa fa-keyboard"></i>
          Гарячі клавіші
        </button>
      </div>

      <!-- Tab Content -->
      <div class="tab-content-v2">
        <!-- Videos Tab -->
        <div v-if="videos.length > 0 && tabIndex === 0" class="tab-pane-v2">
          <div class="videos-grid-v2">
            <div class="video-card-v2" v-for="video in videos" :key="video.id">
              <div class="video-poster-v2">
                <img :src="video.poster" :alt="video.title" />
                <div class="play-overlay-v2" @click="showVideo(video)">
                  <i class="fa fa-play"></i>
                </div>
              </div>
              <div class="video-content-v2">
                <h3 class="video-title-v2">{{ video.title }}</h3>
                <p class="video-description-v2">{{ video.description }}</p>
                <button class="btn btn-primary btn-sm" @click="showVideo(video)">
                  <i class="fa fa-play mr-2"></i>
                  Дивитись відео
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Templates Tab -->
        <div v-if="tabIndex === (videos.length > 0 ? 1 : 0)" class="tab-pane-v2">
          <div class="templates-grid-v2">

            <!-- Template 1 -->
            <div class="template-card-v2">
              <div class="template-image-v2">
                <img :src="require('@/assets/img/1.jpg')" alt="Шаблон 1" />
                <div class="template-number-v2">№1</div>
              </div>
              <div class="template-content-v2">
                <div class="template-header-v2">
                  <h3 class="template-title-v2">Відсутній (№1)</h3>
                </div>
                <div class="template-details-v2">
                  <div class="detail-section-v2">
                    <h4><i class="fa fa-ruler"></i> Розміри деталі, мм:</h4>
                    <ul>
                      <li>Мінімальні (без оклеювання кромкою) – 20х20</li>
                      <li>Мінімальні (з оклеюванням кромкою)* – 120х70</li>
                    </ul>
                  </div>
                  <div class="detail-section-v2">
                    <h4><i class="fa fa-info-circle"></i> Примітки:</h4>
                    <ul>
                      <li>* можливе зменшення розмірів при підрізці з однієї або двох сторін</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- Template 2 -->
            <div class="template-card-v2">
              <div class="template-image-v2">
                <img :src="require('@/assets/img/2.jpg')" alt="Шаблон 2" />
                <div class="template-number-v2">№2</div>
              </div>
              <div class="template-content-v2">
                <div class="template-header-v2">
                  <h3 class="template-title-v2">Косі різи (№2)</h3>
                </div>
                <div class="template-details-v2">
                  <div class="detail-section-v2">
                    <h4><i class="fa fa-ruler"></i> Розміри деталі, мм:</h4>
                    <ul>
                      <li>Мінімальні (без оклеювання кромкою) – 20х20</li>
                      <li>Мінімальні (з оклеюванням кромкою)* – 120х70</li>
                    </ul>
                  </div>
                  <div class="detail-section-v2">
                    <h4><i class="fa fa-cogs"></i> Параметри:</h4>
                    <ul>
                      <li>Кут знизу ліворуч:
                        <ul>
                          <li>відступ з права (Р1), мм</li>
                          <li>відступ знизу (Р2), мм</li>
                        </ul>
                      </li>
                      <li>Кут знизу праворуч:
                        <ul>
                          <li>відступ з ліва (Р3), мм</li>
                          <li>відступ знизу (Р4), мм</li>
                        </ul>
                      </li>
                      <li>Оклеювання кромкою косого різу</li>
                    </ul>
                  </div>
                  <div class="detail-section-v2">
                    <h4><i class="fa fa-exclamation-triangle"></i> Обмеження:</h4>
                    <ul>
                      <li>Р1, Р3 – не більше ширини деталі</li>
                      <li>(Р2+Р4) – не більше довжини деталі</li>
                    </ul>
                  </div>
                  <div class="detail-section-v2">
                    <h4><i class="fa fa-info-circle"></i> Примітки:</h4>
                    <ul>
                      <li>* можливе зменшення розмірів при підрізці з однієї або двох сторін</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- Template 3 -->
            <div class="template-card-v2">
              <div class="template-image-v2">
                <img :src="require('@/assets/img/3.jpg')" alt="Шаблон 3" />
                <div class="template-number-v2">№3</div>
              </div>
              <div class="template-content-v2">
                <div class="template-header-v2">
                  <h3 class="template-title-v2">Фрезерування по дузі (№3)</h3>
                </div>
                <div class="template-details-v2">
                  <div class="detail-section-v2">
                    <h4><i class="fa fa-ruler"></i> Розміри деталі, мм:</h4>
                    <ul>
                      <li>Мінімальні (без оклеювання кромкою)*:
                        <ul>
                          <li>1 радіус – 350х60</li>
                          <li>2 радіуса – 400х60</li>
                          <li>3 або 4 радіуса – 400х120</li>
                        </ul>
                      </li>
                      <li>Мінімальні (з оклеюванням кромкою)*:
                        <ul>
                          <li>1 радіус – 350х70</li>
                          <li>2 радіуса – 400х70</li>
                          <li>3 або 4 радіуса – 400х120</li>
                        </ul>
                      </li>
                      <li>Максимальні – 2800х1550</li>
                    </ul>
                  </div>
                  <div class="detail-section-v2">
                    <h4><i class="fa fa-cogs"></i> Параметри:</h4>
                    <ul>
                      <li>Радіус кута, мм:
                        <ul>
                          <li>вгорі ліворуч (Р1)</li>
                          <li>знизу ліворуч (Р2)</li>
                          <li>знизу праворуч (Р3)</li>
                          <li>вгорі праворуч (Р4)</li>
                        </ul>
                      </li>
                      <li>Оклеювання кромкою фрезерування</li>
                    </ul>
                  </div>
                  <div class="detail-section-v2">
                    <h4><i class="fa fa-exclamation-triangle"></i> Обмеження:</h4>
                    <ul>
                      <li>(Р1+Р2), (Р3+Р4) – не більше ширини деталі</li>
                      <li>(Р1+Р4), (Р2+Р3) – не більше довжини деталі</li>
                    </ul>
                  </div>
                  <div class="detail-section-v2">
                    <h4><i class="fa fa-info-circle"></i> Примітки:</h4>
                    <ul>
                      <li>* можливе зменшення розмірів при підрізці з однієї або двох сторін</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- Template 4 -->
            <div class="template-card-v2">
              <div class="template-image-v2">
                <img :src="require('@/assets/img/4.jpg')" alt="Шаблон 4" />
                <div class="template-number-v2">№4</div>
              </div>
              <div class="template-content-v2">
                <div class="template-header-v2">
                  <h3 class="template-title-v2">Вибірка чверті (№4)</h3>
                </div>
                <div class="template-details-v2">
                  <div class="detail-section-v2">
                    <h4><i class="fa fa-ruler"></i> Розміри деталі, мм:</h4>
                    <ul>
                      <li>Мінімальні (без оклеювання кромкою)* – 350х60</li>
                      <li>Мінімальні (з оклеюванням кромкою)* – 350х70</li>
                      <li>Максимальні – 2800х1550</li>
                    </ul>
                  </div>
                  <div class="detail-section-v2">
                    <h4><i class="fa fa-cogs"></i> Параметри:</h4>
                    <ul>
                      <li>Глибина паза (Р1), мм</li>
                      <li>Ширина паза (Р2), мм</li>
                      <li>Обробляємі сторони:
                        <ul>
                          <li>за довжиною (Р3): без обробки, одна, дві</li>
                          <li>за шириною (Р4): без обробки, одна, дві</li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                  <div class="detail-section-v2">
                    <h4><i class="fa fa-exclamation-triangle"></i> Обмеження:</h4>
                    <ul>
                      <li>(Товщина матеріала-Р1) – не менше 8 мм</li>
                    </ul>
                  </div>
                  <div class="detail-section-v2">
                    <h4><i class="fa fa-info-circle"></i> Примітки:</h4>
                    <ul>
                      <li>* можливе зменшення розмірів при підрізці з однієї або двох сторін</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- Template 5 -->
            <div class="template-card-v2">
              <div class="template-image-v2">
                <img :src="require('@/assets/img/5.jpg')" alt="Шаблон 5" />
                <div class="template-number-v2">№5</div>
              </div>
              <div class="template-content-v2">
                <div class="template-header-v2">
                  <h3 class="template-title-v2">Паз під ДВП (№5)</h3>
                </div>
                <div class="template-details-v2">
                  <div class="detail-section-v2">
                    <h4><i class="fa fa-ruler"></i> Розміри деталі, мм:</h4>
                    <ul>
                      <li>Мінімальні (без оклеювання кромкою) – 20х20</li>
                      <li>Мінімальні (з оклеюванням кромкою)* – 120х70</li>
                    </ul>
                  </div>
                  <div class="detail-section-v2">
                    <h4><i class="fa fa-cogs"></i> Параметри:</h4>
                    <ul>
                      <li>Глибина паза (Р1), мм</li>
                      <li>Ширина паза (Р2), мм</li>
                      <li>Відступ (Р3), мм</li>
                      <li>Розташування (Р4): за довжиною, за шириною</li>
                    </ul>
                  </div>
                  <div class="detail-section-v2">
                    <h4><i class="fa fa-exclamation-triangle"></i> Обмеження:</h4>
                    <ul>
                      <li>(Товщина матеріала-Р1) – не менше 8 мм</li>
                      <li>Р2 – 3 або 4 мм</li>
                      <li>Р3 – не менше 8 мм</li>
                    </ul>
                  </div>
                  <div class="detail-section-v2">
                    <h4><i class="fa fa-info-circle"></i> Примітки:</h4>
                    <ul>
                      <li>* можливе зменшення розмірів при підрізці з однієї або двох сторін</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- Template 6 -->
            <div class="template-card-v2">
              <div class="template-image-v2">
                <img :src="require('@/assets/img/6.jpg')" alt="Шаблон 6" />
                <div class="template-number-v2">№6</div>
              </div>
              <div class="template-content-v2">
                <div class="template-header-v2">
                  <h3 class="template-title-v2">Нестандартне фрезерування (№6)</h3>
                </div>
                <div class="template-details-v2">
                  <div class="detail-section-v2">
                    <h4><i class="fa fa-ruler"></i> Розміри деталі, мм:</h4>
                    <ul>
                      <li>Мінімальні (без оклеювання кромкою)* – 350х60</li>
                      <li>Мінімальні (з оклеюванням кромкою)* – 350х70</li>
                      <li>Максимальні – 2800х1550</li>
                      <li>Максимальні для стільниць – 4100х1550</li>
                    </ul>
                  </div>
                  <div class="detail-section-v2">
                    <h4><i class="fa fa-cogs"></i> Параметри:</h4>
                    <ul>
                      <li>Обробляємі сторони:
                        <ul>
                          <li>за довжиною (Р1): без обробки, одна, дві</li>
                          <li>за шириною (Р2): без обробки, одна, дві</li>
                        </ul>
                      </li>
                      <li>Оклеювання кромкою фрезерування</li>
                      <li>Ескіз деталі – завантаження файлу (обов'язково)</li>
                    </ul>
                  </div>
                  <div class="detail-section-v2">
                    <h4><i class="fa fa-info-circle"></i> Примітки:</h4>
                    <ul>
                      <li>* можливе зменшення розмірів при підрізці з однієї або двох сторін</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- Template 7 -->
            <div class="template-card-v2">
              <div class="template-image-v2">
                <img :src="require('@/assets/img/7.jpg')" alt="Шаблон 7" />
                <div class="template-number-v2">№7</div>
              </div>
              <div class="template-content-v2">
                <div class="template-header-v2">
                  <h3 class="template-title-v2">Різ під нахилом пили (№7)</h3>
                </div>
                <div class="template-details-v2">
                  <div class="detail-section-v2">
                    <h4><i class="fa fa-ruler"></i> Розміри деталі, мм:</h4>
                    <ul>
                      <li>Мінімальні (без оклеювання кромкою) – 120х70</li>
                      <li>Мінімальні (з оклеюванням кромкою)* – 120х70</li>
                    </ul>
                  </div>
                  <div class="detail-section-v2">
                    <h4><i class="fa fa-cogs"></i> Параметри:</h4>
                    <ul>
                      <li>Обробляємі сторони:
                        <ul>
                          <li>за довжиною (Р1): без обробки, одна, дві</li>
                          <li>за шириною (Р2): без обробки, одна, дві</li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                  <div class="detail-section-v2">
                    <h4><i class="fa fa-info-circle"></i> Примітки:</h4>
                    <ul>
                      <li>* можливе зменшення розмірів при підрізці з однієї або двох сторін</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- Template 8 -->
            <div class="template-card-v2">
              <div class="template-image-v2">
                <img :src="require('@/assets/img/8.jpg')" alt="Шаблон 8" />
                <div class="template-number-v2">№8</div>
              </div>
              <div class="template-content-v2">
                <div class="template-header-v2">
                  <h3 class="template-title-v2">Фрезерування під петлі (№8)</h3>
                </div>
                <div class="template-details-v2">
                  <div class="detail-section-v2">
                    <h4><i class="fa fa-ruler"></i> Розміри деталі, мм:</h4>
                    <ul>
                      <li>Мінімальні (без оклеювання кромкою) – 20х20</li>
                      <li>Мінімальні (з оклеюванням кромкою)* – 120х70</li>
                      <li>Максимальні – 2800х850</li>
                    </ul>
                  </div>
                  <div class="detail-section-v2">
                    <h4><i class="fa fa-cogs"></i> Параметри:</h4>
                    <ul>
                      <li>Кількість петель (Р1)</li>
                      <li>Розташування (Р2): за довжиною, за шириною</li>
                    </ul>
                  </div>
                  <div class="detail-section-v2">
                    <h4><i class="fa fa-exclamation-triangle"></i> Обмеження:</h4>
                    <ul>
                      <li>Р1 – від 2 до 7</li>
                    </ul>
                  </div>
                  <div class="detail-section-v2">
                    <h4><i class="fa fa-info-circle"></i> Примітки:</h4>
                    <ul>
                      <li>* можливе зменшення розмірів при підрізці з однієї або двох сторін</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- Template 9 -->
            <div class="template-card-v2">
              <div class="template-image-v2">
                <img :src="require('@/assets/img/9.jpg')" alt="Шаблон 9" />
                <div class="template-number-v2">№9</div>
              </div>
              <div class="template-content-v2">
                <div class="template-header-v2">
                  <h3 class="template-title-v2">Виріз для фасаду без ручок (№9)</h3>
                </div>
                <div class="template-details-v2">
                  <div class="detail-section-v2">
                    <h4><i class="fa fa-ruler"></i> Розміри деталі, мм:</h4>
                    <ul>
                      <li>Мінімальні (без оклеювання кромкою) – 300х60</li>
                      <li>Мінімальні (з оклеюванням кромкою) – 300х70</li>
                      <li>Максимальні – 2800х1550</li>
                    </ul>
                  </div>
                  <div class="detail-section-v2">
                    <h4><i class="fa fa-cogs"></i> Параметри:</h4>
                    <ul>
                      <li>Розташування (Р1): за довжиною, за шириною</li>
                      <li>Оклеювання кромкою вирізу</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- Hotkeys Tab -->
        <div v-if="tabIndex === (videos.length > 0 ? 2 : 1)" class="tab-pane-v2">
          <div class="hotkeys-section-v2">
            <div class="hotkeys-card-v2">
              <div class="hotkeys-header-v2">
                <h3><i class="fa fa-keyboard"></i> Навігація по таблиці</h3>
                <p>Ефективна робота з конструктором за допомогою клавіатури</p>
              </div>
              <div class="hotkeys-content-v2">
                <div class="hotkeys-grid-v2">
                  <div class="hotkey-category-v2">
                    <h4><i class="fa fa-arrow-circle-up"></i> Основна навігація</h4>
                    <div class="hotkey-list-v2">
                      <div class="hotkey-item-v2">
                        <div class="hotkey-keys-v2"><kbd>↑</kbd></div>
                        <div class="hotkey-desc-v2">Перехід до ячейки вище</div>
                      </div>
                      <div class="hotkey-item-v2">
                        <div class="hotkey-keys-v2"><kbd>↓</kbd></div>
                        <div class="hotkey-desc-v2">Перехід до ячейки нижче (створює новий рядок в останньому рядку)
                        </div>
                      </div>
                      <div class="hotkey-item-v2">
                        <div class="hotkey-keys-v2"><kbd>←</kbd></div>
                        <div class="hotkey-desc-v2">Перехід до ячейки зліва (переходить до попереднього рядка в першій
                          ячейці)</div>
                      </div>
                      <div class="hotkey-item-v2">
                        <div class="hotkey-keys-v2"><kbd>→</kbd></div>
                        <div class="hotkey-desc-v2">Перехід до ячейки справа (переходить до наступного рядка в останній
                          ячейці)</div>
                      </div>
                      <div class="hotkey-item-v2">
                        <div class="hotkey-keys-v2"><kbd>Enter</kbd></div>
                        <div class="hotkey-desc-v2">Перехід до наступної ячейки</div>
                      </div>
                      <div class="hotkey-item-v2">
                        <div class="hotkey-keys-v2"><kbd>Tab</kbd></div>
                        <div class="hotkey-desc-v2">Стандартна навігація Tab</div>
                      </div>
                    </div>
                  </div>

                  <div class="hotkey-category-v2">
                    <h4><i class="fa fa-list"></i> Швидкий вибір в селектах</h4>
                    <div class="hotkey-list-v2">
                      <div class="hotkey-item-v2">
                        <div class="hotkey-keys-v2"><kbd>{{ isMac ? 'Ctrl' : 'Alt' }}</kbd> + <kbd>0</kbd></div>
                        <div class="hotkey-desc-v2">Вибір "Ні" (для кромок)</div>
                      </div>
                      <div class="hotkey-item-v2">
                        <div class="hotkey-keys-v2"><kbd>{{ isMac ? 'Ctrl' : 'Alt' }}</kbd> + <kbd>1</kbd></div>
                        <div class="hotkey-desc-v2">Вибір першої опції</div>
                      </div>
                      <div class="hotkey-item-v2">
                        <div class="hotkey-keys-v2"><kbd>{{ isMac ? 'Ctrl' : 'Alt' }}</kbd> + <kbd>2</kbd></div>
                        <div class="hotkey-desc-v2">Вибір другої опції</div>
                      </div>
                      <div class="hotkey-item-v2">
                        <div class="hotkey-keys-v2"><kbd>{{ isMac ? 'Ctrl' : 'Alt' }}</kbd> + <kbd>3</kbd></div>
                        <div class="hotkey-desc-v2">Вибір третьої опції</div>
                      </div>
                      <div class="hotkey-item-v2" v-if="!isMac">
                        <div class="hotkey-keys-v2"><kbd>Ctrl</kbd> + <kbd>цифра</kbd></div>
                        <div class="hotkey-desc-v2">Альтернативний спосіб</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="hotkeys-grid-v2 mt-4">
                  <div class="hotkey-category-v2">
                    <h4><i class="fa fa-check-square"></i> Чекбокси</h4>
                    <div class="hotkey-list-v2">
                      <div class="hotkey-item-v2">
                        <div class="hotkey-keys-v2"><kbd>Space</kbd></div>
                        <div class="hotkey-desc-v2">Перемикання чекбокса</div>
                      </div>
                      <div class="hotkey-item-v2">
                        <div class="hotkey-keys-v2"><kbd>{{ isMac ? 'Ctrl' : 'Alt' }}</kbd> + <kbd>0</kbd></div>
                        <div class="hotkey-desc-v2">Вимкнути чекбокс</div>
                      </div>
                      <div class="hotkey-item-v2">
                        <div class="hotkey-keys-v2"><kbd>{{ isMac ? 'Ctrl' : 'Alt' }}</kbd> + <kbd>1</kbd></div>
                        <div class="hotkey-desc-v2">Увімкнути чекбокс</div>
                      </div>
                    </div>
                  </div>

                  <div class="hotkey-category-v2">
                    <h4><i class="fa fa-magic"></i> Інші гарячі клавіші</h4>
                    <div class="hotkey-list-v2">
                      <div class="hotkey-item-v2">
                        <div class="hotkey-keys-v2"><kbd>{{ isMac ? 'Ctrl' : 'Alt' }}</kbd> + <kbd>+</kbd></div>
                        <div class="hotkey-desc-v2">Додати нову деталь</div>
                      </div>
                      <div class="hotkey-item-v2">
                        <div class="hotkey-keys-v2"><kbd>{{ isMac ? 'Ctrl' : 'Alt' }}</kbd> + <kbd>=</kbd></div>
                        <div class="hotkey-desc-v2">Додати нову деталь (альтернативний)</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="info-panel-v2">
                  <div class="info-card-v2 info-blue">
                    <div class="info-header-v2">
                      <i class="fa fa-info-circle"></i>
                      <h5>Особливості навігації:</h5>
                    </div>
                    <ul>
                      <li>Автоматичний пропуск недоступних елементів (disabled, readonly)</li>
                      <li>Пропуск ячейок без інтерактивних елементів</li>
                      <li>Автоматичне створення нових рядків при досягненні останнього рядка</li>
                      <li>Перехід між рядками при досягненні границь рядка</li>
                      <li>Автоматичне виділення тексту при переході до поля вводу</li>
                      <li>Оновлення 2D візуалізації при переході між рядками</li>
                    </ul>
                  </div>

                  <div class="info-card-v2 info-yellow">
                    <div class="info-header-v2">
                      <i class="fa fa-exclamation-triangle"></i>
                      <h5>Примітки:</h5>
                    </div>
                    <ul>
                      <li v-if="isMac">На Mac використовуйте <kbd>Ctrl</kbd> замість <kbd>Alt</kbd> для уникнення
                        конфліктів з браузером</li>
                      <li v-else>На Windows/Linux використовуйте <kbd>Alt</kbd> для швидкого вибору</li>
                      <li>Навігація працює тільки всередині таблиці деталей</li>
                      <li>При досягненні границь таблиці навігація зупиняється</li>
                      <li>Фокус автоматично переходить до наступного доступного елемента вводу</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-modal id="modalVideo" size="xl" :title="currentVideo.title">
        <b-embed type="video" aspect="16by9" controls :poster="currentVideo.poster">
          <source :src="currentVideo.video" :type="currentVideo.video_type">
        </b-embed>
      </b-modal>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import appconfig from "../app/config";

export default {
  name: "help",
  data() {
    return {
      videos: [],
      tabIndex: 0,
      currentVideo: {
        'title': '',
        'poster': '',
        'video': '',
        'video_type': '',
      },
    }
  },
  computed: {
    // Определяем операционную систему
    isMac() {
      return navigator.platform.toUpperCase().indexOf('MAC') >= 0;
    },

    // Заголовок вкладки в зависимости от ОС
    hotkeysTabTitle() {
      return this.isMac ? 'Гарячі клавіші (Mac)' : 'Гарячі клавіші (Windows/Linux)';
    }
  },
  methods: {
    showVideo(video) {
      this.currentVideo = video;
      this.$bvModal.show('modalVideo')
    }
  },
  mounted() {
    axios.get(
      appconfig.Point + 'api/constructor/v1/video'
    ).then(response => {
      this.videos = response.data.data;
      this.handleHashNavigation();
    }).catch(r => {
      this.handleHashNavigation();
    })
  },
  watch: {
    '$route.hash'() {
      this.handleHashNavigation();
    }
  },
  methods: {
    showVideo(video) {
      this.currentVideo = video;
      this.$bvModal.show('modalVideo')
    },
    handleHashNavigation() {
      const hash = this.$route.hash;
      if (!hash) return;

      // Определяем индекс таба на основе хеша
      let targetTabIndex = 0;

      switch (hash) {
        case '#videos':
          targetTabIndex = 0;
          break;
        case '#templates':
          targetTabIndex = this.videos.length > 0 ? 1 : 0;
          break;
        case '#hotkeys':
          targetTabIndex = this.videos.length > 0 ? 2 : 1;
          break;
        default:
          return;
      }

      // Переключаем таб
      this.tabIndex = targetTabIndex;
    }
  }
}
</script>

<style scoped>
@import '../assets/help.css';

/* Modern Help Page Styles */
.help-container-v2 {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}



/* Card */
.help-card-v2 {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: none;
  overflow: hidden;
}

/* Tabs */
.help-tabs-v2 {
  display: flex;
  border-bottom: 1px solid #e9ecef;
  background: #f8f9fa;
}

.tab-btn-v2 {
  background: none;
  border: none;
  padding: 15px 25px;
  font-size: 1rem;
  font-weight: 500;
  color: #6c757d;
  cursor: pointer;
  transition: all 0.3s ease;
  border-bottom: 3px solid transparent;
  display: flex;
  align-items: center;
  gap: 8px;
}

.tab-btn-v2:hover {
  color: #ff182d;
  background: rgba(255, 24, 45, 0.05);
}

.tab-btn-v2.active {
  color: #ff182d;
  border-bottom-color: #ff182d;
  background: white;
  margin-bottom: -1px;
}

.tab-btn-v2 i {
  font-size: 1.1rem;
}

/* Tab Content */
.tab-content-v2 {
  background: white;
}

.tab-pane-v2 {
  padding: 30px;
}

/* Videos Grid */
.videos-grid-v2 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(400px, 1fr));
  gap: 25px;
}

.video-card-v2 {
  background: white;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 15px rgba(0, 0, 0, 0.08);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.video-card-v2:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
}

.video-poster-v2 {
  position: relative;
  height: 200px;
  overflow: hidden;
}

.video-poster-v2 img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.play-overlay-v2 {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #2196f3;
  color: white;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.play-overlay-v2:hover {
  background: #2196f3;
  transform: translate(-50%, -50%) scale(1.1);
}

.video-content-v2 {
  padding: 20px;
}

.video-title-v2 {
  font-size: 1.3rem;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 10px;
}

.video-description-v2 {
  color: #6c757d;
  line-height: 1.5;
  margin-bottom: 15px;
}

/* Templates Grid */
.templates-grid-v2 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(420px, 1fr));
  gap: 18px;
}

.template-card-v2 {
  background: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid #e9ecef;
}

.template-card-v2:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.template-image-v2 {
  position: relative;
  height: 140px;
  overflow: hidden;
  background: #f8f9fa;
  display: flex;
  align-items: center;
  justify-content: center;
}

.template-image-v2 img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.template-number-v2 {
  position: absolute;
  top: 8px;
  left: 8px;
  background: #2196f3;
  color: white;
  padding: 4px 10px;
  border-radius: 15px;
  font-weight: 600;
  font-size: 0.8rem;
}

.template-content-v2 {
  padding: 15px;
}

.template-header-v2 {
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #e9ecef;
}

.template-title-v2 {
  font-size: 1.2rem;
  font-weight: 600;
  color: #2196f3;
  margin: 0;
}

.template-details-v2 {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.detail-section-v2 h4 {
  font-size: 0.9rem;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.detail-section-v2 h4 i {
  color: #ff182d;
  font-size: 0.8rem;
}

.detail-section-v2 ul {
  margin: 0;
  padding-left: 18px;
}

.detail-section-v2 li {
  margin-bottom: 3px;
  color: #495057;
  line-height: 1.3;
  font-size: 0.85rem;
}

/* Hotkeys Section */
.hotkeys-section-v2 {
  max-width: 900px;
  margin: 0 auto;
}

.hotkeys-card-v2 {
  background: white;
  border-radius: 8px;
  overflow: hidden;
}

.hotkeys-header-v2 {
  text-align: center;
  padding: 20px;
  background: linear-gradient(135deg, #ff182d, #19469e);
  color: white;
}

.hotkeys-header-v2 h3 {
  font-size: 1.5rem;
  font-weight: 600;
  margin-bottom: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.hotkeys-header-v2 p {
  font-size: 0.95rem;
  opacity: 0.9;
  margin: 0;
}

.hotkeys-content-v2 {
  padding: 20px;
}

.hotkeys-grid-v2 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 18px;
  margin-bottom: 18px;
}

.hotkey-category-v2 h4 {
  font-size: 1rem;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 6px;
  border-bottom: 2px solid #ff182d;
}

.hotkey-category-v2 h4 i {
  color: #ff182d;
  font-size: 0.9rem;
}

.hotkey-list-v2 {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.hotkey-item-v2 {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 10px;
  background: #f8f9fa;
  border-radius: 6px;
  transition: background 0.3s ease;
}

.hotkey-item-v2:hover {
  background: #e9ecef;
}

.hotkey-keys-v2 {
  min-width: 100px;
  display: flex;
  gap: 4px;
  align-items: center;
}

.hotkey-keys-v2 kbd {
  background: #fff;
  border: 1px solid #d1d5db;
  border-radius: 3px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  color: #374151;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: 0.75rem;
  font-weight: 500;
  padding: 3px 6px;
  text-align: center;
  min-width: 20px;
}

.hotkey-desc-v2 {
  color: #495057;
  line-height: 1.3;
  flex: 1;
  font-size: 0.9rem;
}

/* Info Panels */
.info-panel-v2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  margin-top: 20px;
}


.info-card-v2 {
  padding: 15px;
  border-radius: 8px;
  border-left: 3px solid;
}

.info-card-v2.info-blue {
  background: #e3f2fd;
  border-left-color: #2196f3;
}

.info-card-v2.info-yellow {
  background: #fff8e1;
  border-left-color: #ff9800;
}

.info-header-v2 {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 10px;
}

.info-header-v2 h5 {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 600;
  color: #2c3e50;
}

.info-header-v2 i {
  font-size: 1rem;
}

.info-blue .info-header-v2 i {
  color: #2196f3;
}

.info-yellow .info-header-v2 i {
  color: #ff9800;
}

.info-card-v2 ul {
  margin: 0;
  padding-left: 18px;
}

.info-card-v2 li {
  margin-bottom: 5px;
  color: #495057;
  line-height: 1.3;
  font-size: 0.85rem;
}

.info-card-v2 kbd {
  background: #fff;
  border: 1px solid #d1d5db;
  border-radius: 3px;
  color: #374151;
  font-size: 0.75rem;
  padding: 2px 5px;
}

/* Buttons */
.btn-primary {
  background-color: #2196f3;
  border-color: #2196f3;
  color: white;
  font-weight: 500;
  padding: 8px 16px;
  border-radius: 6px;
  transition: all 0.3s ease;
}

.btn-primary:hover {
  background-color: #187dcf;
  border-color: #187dcf;
  transform: translateY(-1px);
}

/* Responsive */
@media (max-width: 768px) {
  .help-container-v2 {
    padding: 15px;
  }

  .help-tabs-v2 {
    flex-direction: column;
  }

  .tab-btn-v2 {
    text-align: center;
  }

  .videos-grid-v2,
  .templates-grid-v2 {
    grid-template-columns: 1fr;
  }

  .hotkeys-grid-v2 {
    grid-template-columns: 1fr;
  }

  .info-panel-v2 {
    grid-template-columns: 1fr;
  }

  .hotkey-item-v2 {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    padding: 6px 8px;
  }

  .hotkey-keys-v2 {
    min-width: auto;
  }

  .hotkeys-content-v2 {
    padding: 15px;
  }

  .hotkeys-header-v2 {
    padding: 15px;
  }
}

@media (max-width: 480px) {
  .tab-pane-v2 {
    padding: 15px;
  }



  .hotkeys-content-v2 {
    padding: 10px;
  }

  .hotkeys-header-v2 {
    padding: 12px;
  }

  .hotkeys-header-v2 h3 {
    font-size: 1.3rem;
  }

  .info-panel-v2 {
    gap: 10px;
  }

  .info-card-v2 {
    padding: 12px;
  }
}
</style>